import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DadosTerminoAntecipado extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const razaoTerminoAntecipado = this.props.controller.solicitacaoMudancaPrazo.razaoAlteracao
        const razaoOptions = createSelectOptions(this.props.controller.motivosTerminoAntecipado, "nome", "nome");
        const novaDataInicialEditavel = this.props.controller.novaDataInicialEditavel;
        const momentDataTerminoAntecipado = this.props.controller.momentDataTerminoAntecipado;
        const momentDataTermino = _.get(this.props.controller, "solicitacao.momentDataTermino");
        const momentAntesDataTermino = this.props.controller.momentAntesDataTermino;

        return (
            <div>
                <h4>Término antecipado</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Razão término</Label>
                            <Input type="text" value={razaoTerminoAntecipado} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Data final antecipada</Label>
                            <Input type="text" className="form-control" value={momentDataTerminoAntecipado ? moment(momentDataTerminoAntecipado).format("DD/MM/YYYY") : ""} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}